

export default class VideoListItem {
    constructor(item, player) {
        this.player = player;
        this.item = item;
        this.link = item.querySelector('.video-list__item__link');
        this.videoUrl = this.link.getAttribute('href');


        item.addEventListener('click', (e) => {
            e.preventDefault();
            this.player.play(this.videoUrl);
        });
    }

}